export class LoginSession {
    constructor(data = {}) {
        this.sessionId = data.sessionId;
        this.deviceName = data.deviceName || 'دستگاه نامشخص';
        this.browser = data.browser || '-';
        this.os = data.os || '-';
        this.ipAddress = data.ipAddress || '-';
        this.trusted = !!data.trusted;
        this.currentSession = !!data.currentSession;
        this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
        this.lastSeenAt = data.lastSeenAt ? new Date(data.lastSeenAt) : null;
    }

    getDeviceLabel() {
        if (this.browser && this.browser !== '-' && this.os && this.os !== '-') {
            return `${this.browser} • ${this.os}`;
        }
        return this.deviceName;
    }
}

export class TrustedDevice {
    constructor(data = {}) {
        this.id = data.id;
        this.deviceName = data.deviceName || 'دستگاه نامشخص';
        this.browser = data.browser || '-';
        this.os = data.os || '-';
        this.ipAddress = data.ipAddress || '-';
        this.trusted = !!data.trusted;
        this.lastSeenAt = data.lastSeenAt ? new Date(data.lastSeenAt) : null;
        this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
    }
}

export class Passkey {
    constructor(data = {}) {
        this.id = data.id;
        this.name = data.name || 'Passkey';
        this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
        this.lastUsedAt = data.lastUsedAt ? new Date(data.lastUsedAt) : null;
    }
}

export class SecurityEvent {
    constructor(data = {}) {
        this.id = data.id;
        this.eventType = data.eventType;
        this.ipAddress = data.ipAddress || '-';
        this.deviceName = data.deviceName || '-';
        this.metadata = data.metadata || null;
        this.createdAt = data.createdAt ? new Date(data.createdAt) : null;
    }

    getIcon() {
        const icons = {
            LOGIN: 'arrow-right-rectangle',
            LOGIN_FAILED: 'triangle-warning',
            LOGIN_MFA_REQUIRED: 'shield-star',
            NEW_DEVICE: 'smartphone',
            HIGH_RISK_IP: 'triangle-warning',
            MFA_ENABLED: 'shield-star',
            MFA_DISABLED: 'lock-open',
            MFA_VERIFIED: 'circle-check',
            PASSKEY_REGISTERED: 'key',
            PASSKEY_REMOVED: 'trash',
            RECOVERY_CODES_GENERATED: 'receipt-checked',
            RECOVERY_CODE_USED: 'receipt-checked',
            SESSION_TERMINATED: 'cross',
            DEVICE_TRUSTED: 'circle-check',
            DEVICE_TRUST_REVOKED: 'cross',
            STEP_UP_PASSED: 'circle-check',
            STEP_UP_REQUIRED: 'shield-star',
        };
        return icons[this.eventType] || 'circle-information';
    }

    getVariant() {
        const variants = {
            LOGIN: 'info',
            LOGIN_FAILED: 'alert',
            LOGIN_MFA_REQUIRED: 'warning',
            NEW_DEVICE: 'warning',
            HIGH_RISK_IP: 'alert',
            MFA_ENABLED: 'success',
            MFA_DISABLED: 'alert',
            MFA_VERIFIED: 'success',
            PASSKEY_REGISTERED: 'success',
            PASSKEY_REMOVED: 'alert',
            RECOVERY_CODES_GENERATED: 'info',
            RECOVERY_CODE_USED: 'info',
            SESSION_TERMINATED: 'neutral',
            DEVICE_TRUSTED: 'success',
            DEVICE_TRUST_REVOKED: 'alert',
            STEP_UP_PASSED: 'success',
            STEP_UP_REQUIRED: 'warning',
        };
        return variants[this.eventType] || 'neutral';
    }

    getLabel() {
        const labels = {
            LOGIN: 'ورود به حساب',
            LOGIN_FAILED: 'تلاش ناموفق ورود',
            LOGIN_MFA_REQUIRED: 'ورود نیازمند تأیید دو مرحلهای',
            NEW_DEVICE: 'دستگاه جدید شناسایی شد',
            HIGH_RISK_IP: 'هشدار امنیتی',
            MFA_ENABLED: 'احراز هویت دو مرحله‌ای فعال شد',
            MFA_DISABLED: 'احراز هویت دو مرحله‌ای غیرفعال شد',
            MFA_VERIFIED: 'تأیید احراز هویت',
            PASSKEY_REGISTERED: 'Passkey ثبت شد',
            PASSKEY_REMOVED: 'Passkey حذف شد',
            RECOVERY_CODES_GENERATED: 'کدهای بازیابی تولید شدند',
            RECOVERY_CODE_USED: 'کد بازیابی استفاده شد',
            SESSION_TERMINATED: 'جلسه بسته شد',
            DEVICE_TRUSTED: 'دستگاه مورد اعتماد قرار گرفت',
            DEVICE_TRUST_REVOKED: 'اعتماد به دستگاه لغو شد',
            STEP_UP_PASSED: 'تأیید مجدد هویت انجام شد',
            STEP_UP_REQUIRED: 'نیازمند تأیید مجدد هویت',
        };
        return labels[this.eventType] || this.eventType;
    }
}

export default {
    LoginSession,
    TrustedDevice,
    Passkey,
    SecurityEvent,
};